import { Box, Text } from 'braid-design-system';
import type { ReactNode } from 'react';

import type { SearchResultItem } from '#search/types.ts';
import * as styles from './SearchResult.css';

const parseHighlights = (content: string): ReactNode[] => {
  const result: ReactNode[] = [];
  let highlight = false;

  content.split(/(<mark>|<\/mark>)/g).forEach((part, index) => {
    if (part === '<mark>') {
      highlight = true;
    } else if (part === '</mark>') {
      highlight = false;
    } else {
      result.push(
        <Box
          component="span"
          key={index}
          className={highlight ? styles.highlight : undefined}
        >
          {part}
        </Box>,
      );
    }
  });

  return result;
};

export const SearchResult = ({ result }: { result: SearchResultItem }) => (
  <Box
    component="span"
    display="flex"
    justifyContent="spaceBetween"
    paddingX="small"
    paddingY="xsmall"
    flexDirection="column"
  >
    <Text baseline={false} size="small" weight="medium">
      {parseHighlights(result.titleHighlight)}
    </Text>
    {result.contentSnippet ? (
      <Text size="small" tone="secondary" baseline={false}>
        {parseHighlights(result.contentSnippet)}
      </Text>
    ) : null}
  </Box>
);
